import styled from 'styled-components';
import { getFontSize } from '../utils/getFont';
import { Phone } from '../assets/icons';

const Container = styled.div`
  display: flex; /* flex para icono + input */
  align-items: center;
  background-color: var(--background-alt);
  border-radius: 6px;
  border: ${({ bordered }) => (bordered ? '2px solid var(--text)' : 'none')};
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop}px;` : '')}

  input {
    flex: 1;
    padding: 10px;
    border: none;
    border-radius: 6px;
    background-color: var(--background-alt);
    color: var(--text);
    ${({ fontSize }) => getFontSize(fontSize)}
    outline: none;
    cursor: text;

    &::placeholder {
      color: var(--primary-light);
      opacity: 0.6;
    }
  }

  ${({ borderBottom }) =>
    borderBottom &&
    `
    background-color: transparent;

    input {
      padding: 10px 6px 6px;
      border-bottom: 2px solid var(--text);
      border-radius: 0;
    }
  `}
`;

export const Input = ({
  type = 'text',
  value,
  fontSize = 4,
  maxWidth = '100%',
  placeholder,
  onChange,
  onFocus,
  onBlur,
  autoFocus,
  bordered,
  borderBottom,
  marginTop = 0,
}) => {
  const handleFocus = (e) => {
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e) => {
    if (onBlur) onBlur(e);
  };

  const handleChange = (e) => {
    if (onChange) onChange(e.target.value);
  };

  return (
    <Container
      bordered={bordered}
      borderBottom={borderBottom}
      fontSize={fontSize}
      marginTop={marginTop}
      maxWidth={maxWidth}
    >
      {type === 'phoneNumber' && <Phone />}
      <input
        type={type === 'phoneNumber' ? 'tel' : type}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoFocus={autoFocus}
      />
    </Container>
  );
};
